<div class="dpicker" [class.check-in-out-styling]="checkInOutStyling" [class.preventSelection]="preventSelection">
  <section>
    <div
      role="button"
      aria-label="Previous month"
      class="dpicker-prev-month-btn flex items-center justify-center"
      (click)="changeMonth(-1)">
      <ui-icon icon="griddy-chevron-left" class="text-raspberry-darker" [size]="14"></ui-icon>
    </div>

    <div
      role="button"
      aria-label="Next month"
      class="dpicker-next-month-btn flex items-center justify-center"
      (click)="changeMonth(1)">
      <ui-icon icon="griddy-chevron-right" class="text-raspberry-darker" [size]="14"></ui-icon>
    </div>

    <div *ngFor="let month of dates" class="dpicker-month-container" [style.width.px]="cellSizePx * 7">
      <div class="dpicker-month-title" aria-label="Month">
        <span>{{ month[10] | date: 'MMM' }}</span>
        <span class="ml-1">{{ month[10] | date: 'yy' }}</span>
      </div>

      <div>
        <div *ngFor="let dow of daysOfWeek" class="dpicker-dow">{{ dow }}</div>
      </div>

      <div class="dpicker-month-dates">
        <button
          *ngFor="let date of month"
          [attr.aria-label]="date"
          [disabled]="
            (preventPastDatesSelection && date && (date | isBeforeToday)) ||
            (preventFutureDatesSelection && date && (date | isAfterToday)) ||
            (date && !isDateWithinAllowedRange(date))
          "
          class="dpicker-date flex items-center justify-center"
          [class.dpicker-picked-date]="
            (selectedFirstDateInRange && selectedFirstDateInRange === date) ||
            (selectedDates.length && date && selectedDates.indexOf(date) > -1)
          "
          [class.dpicker-hovered-date]="
            !selectedSecondDateInRange && hoveredDates.length && date && hoveredDates.indexOf(date) > -1
          "
          [class.dpicker-hovered-date-final]="
            !selectedSecondDateInRange && hoveredDates.length && hoveredDates[hoveredDates.length - 1] === date
          "
          [class.no-day]="date === null"
          [class.first-picked-date]="selectedFirstDateInRange === date && date !== null"
          [class.last-picked-date]="selectedDates.length && selectedDates[selectedDates.length - 1] === date"
          [class.blocked-checkin]="date && blockedDates[date] === 'checkin'"
          [class.blocked-staying]="date && blockedDates[date] === 'staying'"
          [class.blocked-checkout]="date && blockedDates[date] === 'checkout'"
          [class.blocked-changeover]="date && blockedDates[date] === 'changeover'"
          [class.date-unselectable]="
            (preventPastDatesSelection && date && (date | isBeforeToday)) ||
            (preventFutureDatesSelection && date && (date | isAfterToday)) ||
            (date && !isDateWithinAllowedRange(date))
          "
          [style.width.px]="cellSizePx"
          [style.height.px]="cellSizePx"
          (click)="clickedDate(date)"
          (mouseover)="hoveredDate(date)">
          <span>{{ date ? (date | date: 'd') : null }}</span>
        </button>
      </div>
    </div>
  </section>

  <div *ngIf="showDurationLabels" class="text__small night selected-labels strong flex gap-1">
    <span *ngIf="selectedFirstDateInRange && selectedSecondDateInRange">
      {{ selectedFirstDateInRange ? (selectedFirstDateInRange | date) : null }}
      -
      {{ selectedSecondDateInRange ? (selectedSecondDateInRange | date) : null }}
    </span>
    <span *ngIf="selectedFirstDateInRange && selectedSecondDateInRange">
      ({{ selectedFirstDateInRange | numNights: selectedSecondDateInRange }} night stay)
    </span>
    <span>&nbsp;</span>
  </div>
</div>
